import "../../../chunk-D57E6H3M.mjs";

// src/components/composite/ChatMessage/messageCopyText.ts
import { ChatRole } from "../../../domain/index.mjs";
function getMessageCopyText(message) {
  if (message.role === ChatRole.User) return message.content ?? "";
  const fromTimeline = message.timeline?.filter((item) => item.type === "content").map((item) => item.content).join("\n") ?? "";
  const legacyContent = message.content?.trim();
  return fromTimeline || legacyContent || "";
}
export {
  getMessageCopyText
};
//# sourceMappingURL=messageCopyText.mjs.map